import redArrowDown from "../../../../../../../assets/static/images/commerce/chain-offer/red-arrow-down.png";
import redArrowLeft from "../../../../../../../assets/static/images/commerce/chain-offer/red-arrow-left.png";
import redArrowRight from "../../../../../../../assets/static/images/commerce/chain-offer/red-arrow-right.png";
import type {
    ChainOfferBoardPhase,
    ChainOfferStep,
} from "../../../../../../../logic/helpers/commerceChainPresentation";
import { ChainOfferCompletionScene } from "../ChainOfferCompletionScene/ChainOfferCompletionScene";
import { ChainOfferStepCard } from "../ChainOfferStepCard/ChainOfferStepCard";
import "./ChainOfferBoard.scss";

interface ChainOfferBoardProps {
    steps: ChainOfferStep[];
    incomingStep: ChainOfferStep | null;
    phase: ChainOfferBoardPhase;
    locale: string;
    isBusy: boolean;
    isExpired: boolean;
    totalStepCount: number;
    onActivate: (step: ChainOfferStep) => void;
}

const CONNECTORS = [
    { direction: "right-top", src: redArrowRight },
    { direction: "down-right", src: redArrowDown },
    { direction: "left-middle", src: redArrowLeft },
    { direction: "down-left", src: redArrowDown },
    { direction: "right-bottom", src: redArrowRight },
] as const;

export function ChainOfferBoard({
    steps,
    incomingStep,
    phase,
    locale,
    isBusy,
    isExpired,
    totalStepCount,
    onActivate,
}: ChainOfferBoardProps) {
    return (
        <div className="chain-offer-board" data-board-phase={phase} dir="ltr">
            <ol className="chain-offer-board__steps">
                {steps.map((step, index) => (
                    <ChainOfferStepCard
                        key={step.stepKey}
                        step={step}
                        slotIndex={index}
                        locale={locale}
                        boardPhase={phase}
                        isBusy={isBusy}
                        isExpired={isExpired}
                        onActivate={onActivate}
                    />
                ))}
            </ol>

            {incomingStep && phase === "advancing" && (
                <ol className="chain-offer-board__incoming" aria-hidden="true">
                    <ChainOfferStepCard
                        step={incomingStep}
                        slotIndex={5}
                        locale={locale}
                        boardPhase={phase}
                        isBusy
                        isExpired={isExpired}
                        isPresentationOnly
                        onActivate={() => undefined}
                    />
                </ol>
            )}

            <div className="chain-offer-board__connectors" aria-hidden="true">
                {CONNECTORS.map((connector) => (
                    <img
                        key={connector.direction}
                        className="chain-offer-board__connector"
                        data-direction={connector.direction}
                        src={connector.src}
                        alt=""
                        draggable={false}
                    />
                ))}
            </div>

            {phase === "complete" && (
                <ChainOfferCompletionScene
                    current={totalStepCount}
                    total={totalStepCount}
                />
            )}
        </div>
    );
}
